export type AboutStat = { v: string; k: string };
export type AboutPerson = { name: string; role: string; about: string };
export type AboutAvatar = { i: string; bg: string };
export type AboutQuote = { stars: string; text: string; name: string };

export type AboutCopy = {
  heroTitleBefore: string;
  heroTitleHighlight: string;
  heroTitleAfter: string;
  heroSub: string;
  heroPhotoLabel: string;
  stats: AboutStat[];
  teamTitleBefore: string;
  teamTitleHighlight: string;
  teamSub: string;
  showAll: string;
  showLess: string;
  portraitLabel: string;
  people: AboutPerson[];
  reviewsTitleBefore: string;
  reviewsTitleHighlight: string;
  reviewsTitleAfter: string;
  reviewsCount: string;
  reviewsAvg: string;
  avatars: AboutAvatar[];
  quotes: AboutQuote[];
  footerTagline: string;
  footerProduct: string;
  footerCompany: string;
  footerSupport: string;
  footerLegal: string;
  footerShifts: string;
  footerAttendance: string;
  footerContracts: string;
  footerHiring: string;
  footerAbout: string;
  footerCareers: string;
  footerBlog: string;
  footerHelp: string;
  footerContact: string;
  footerStatus: string;
  footerGdpr: string;
  footerTerms: string;
  footerCookies: string;
  footerPrivacy: string;
  footerTermsShort: string;
  linkedIn: string;
};

const CS: AboutCopy = {
  heroTitleBefore: 'Poznejte tým ',
  heroTitleHighlight: 'Ompli',
  heroTitleAfter: '',
  heroSub:
    'Pomáháme firmám obsadit směny a brigádníkům najít práci bez zbytečného papírování. Jsme malý tým v Praze, který věří, že plánování lidí nemusí končit v Excelu.',
  heroPhotoLabel: 'skupinová fotka týmu - kancelář / coworking',
  stats: [
    { v: '2021', k: 'založeno v Praze' },
    { v: '12', k: 'lidí v týmu' },
    { v: '600+', k: 'firem používá Ompli' },
    { v: '1,2 mil.', k: 'naplánovaných směn' },
  ],
  teamTitleBefore: 'Lidé za ',
  teamTitleHighlight: 'Ompli',
  teamSub:
    'Produkťáci, vývojáři a lidé z provozu, kteří sami roky plánovali směny. Stavíme jen to, co bychom chtěli používat i my.',
  showAll: 'Zobrazit všechny',
  showLess: 'Zobrazit méně',
  portraitLabel: 'portrétní foto',
  people: [
    {
      name: 'Jiří Kolb',
      role: 'Co-Owner, PO',
      about: 'Stará se o produkt a rozhoduje, co se do Ompli přidá dřív. Mluví s firmami každý týden.',
    },
    {
      name: 'Jan Straka',
      role: 'Co Owner',
      about: 'Spoluvlastní Ompli a drží směr firmy - od obchodu po dlouhodobou vizi produktu.',
    },
    {
      name: 'Tim Nguyen',
      role: 'CTO',
      about: 'Vede vývoj plánování směn a hlídá, aby appka zvládla i rozpis pro stovky lidí.',
    },
    {
      name: 'Adam Procházka',
      role: 'Developer',
      about: 'Staví funkce, které používáte každý den - od směn po docházku a smlouvy.',
    },
    {
      name: 'Jan Straka Jr.',
      role: 'Business Development',
      about: 'Provází firmy prvním nastavením - od importu lidí po první hotový rozpis.',
    },
    {
      name: 'Robert Málek',
      role: 'Brand Manager',
      about: 'Hlídá, jak Ompli vypadá a mluví ven - od webu po vizuální styl značky.',
    },
  ],
  reviewsTitleBefore: 'Oblíbené mezi ',
  reviewsTitleHighlight: 'firmami',
  reviewsTitleAfter: ' po celé ČR',
  reviewsCount: '240+ recenzí',
  reviewsAvg: 'průměr 4,8 z 5',
  avatars: [
    { i: 'K', bg: '#0065F4' },
    { i: 'M', bg: '#7FA9F7' },
    { i: 'V', bg: '#111827' },
    { i: 'L', bg: '#FFB400' },
  ],
  quotes: [
    {
      stars: '★★★★★',
      text: 'Rozpis směn nám dřív zabral celé nedělní odpoledne. Dnes ho máme hotový za dvacet minut a brigádníci si výměny řeší sami.',
      name: 'Klára Nováková',
    },
    {
      stars: '★★★★★',
      text: 'Přešli jsme z Excelu a tabulek v chatu. Docházka i podklady pro mzdy sedí na první pokus - účetní si to konečně pochvaluje.',
      name: 'Petr Doležal',
    },
    {
      stars: '★★★★☆',
      text: 'Nábor brigádníků na sezónu jsme zvládli o polovinu rychleji. Smlouvy podepisujeme online, papíry v šuplíku jsou minulost.',
      name: 'Michaela Svobodová',
    },
  ],
  footerTagline: 'Směny, docházka, smlouvy a nábor v jedné aplikaci pro rostoucí firmy.',
  footerProduct: 'Produkt',
  footerCompany: 'Společnost',
  footerSupport: 'Podpora',
  footerLegal: 'Právní',
  footerShifts: 'Směny',
  footerAttendance: 'Docházka',
  footerContracts: 'Smlouvy',
  footerHiring: 'Nábor',
  footerAbout: 'O nás',
  footerCareers: 'Kariéra',
  footerBlog: 'Blog',
  footerHelp: 'Nápověda',
  footerContact: 'Kontakt',
  footerStatus: 'Stav služby',
  footerGdpr: 'GDPR',
  footerTerms: 'Obchodní podmínky',
  footerCookies: 'Cookies',
  footerPrivacy: 'Ochrana soukromí',
  footerTermsShort: 'Podmínky',
  linkedIn: 'LinkedIn',
};

const EN: AboutCopy = {
  heroTitleBefore: 'Meet the ',
  heroTitleHighlight: 'Ompli',
  heroTitleAfter: ' team',
  heroSub:
    'We help companies fill shifts and temps find work without the paperwork. We’re a small Prague team who believe scheduling people doesn’t have to end in Excel.',
  heroPhotoLabel: 'team group photo - office / coworking',
  stats: [
    { v: '2021', k: 'founded in Prague' },
    { v: '12', k: 'people on the team' },
    { v: '600+', k: 'companies use Ompli' },
    { v: '1.2M', k: 'shifts planned' },
  ],
  teamTitleBefore: 'People behind ',
  teamTitleHighlight: 'Ompli',
  teamSub:
    'Product, engineering, and ops folks who spent years scheduling shifts themselves. We only build what we’d want to use too.',
  showAll: 'Show all',
  showLess: 'Show less',
  portraitLabel: 'portrait photo',
  people: [
    {
      name: 'Jiří Kolb',
      role: 'Co-Owner, PO',
      about: 'Owns the product and decides what ships next in Ompli. Talks to companies every week.',
    },
    {
      name: 'Jan Straka',
      role: 'Co Owner',
      about: 'Co-owns Ompli and sets the company direction - from sales to the long-term product vision.',
    },
    {
      name: 'Tim Nguyen',
      role: 'CTO',
      about: 'Leads shift scheduling engineering and keeps the app ready for hundreds of people on a roster.',
    },
    {
      name: 'Adam Procházka',
      role: 'Developer',
      about: 'Builds the features you use every day - from shifts to attendance and contracts.',
    },
    {
      name: 'Jan Straka Jr.',
      role: 'Business Development',
      about: 'Guides companies through first setup - from importing people to the first finished roster.',
    },
    {
      name: 'Robert Málek',
      role: 'Brand Manager',
      about: 'Owns how Ompli looks and sounds outside - from the website to the brand visual system.',
    },
  ],
  reviewsTitleBefore: 'Loved by ',
  reviewsTitleHighlight: 'companies',
  reviewsTitleAfter: ' across Czechia',
  reviewsCount: '240+ reviews',
  reviewsAvg: 'average 4.8 out of 5',
  avatars: [
    { i: 'K', bg: '#0065F4' },
    { i: 'M', bg: '#7FA9F7' },
    { i: 'V', bg: '#111827' },
    { i: 'L', bg: '#FFB400' },
  ],
  quotes: [
    {
      stars: '★★★★★',
      text: 'Shift planning used to eat our whole Sunday afternoon. Now it’s done in twenty minutes and temps handle swaps themselves.',
      name: 'Klára Nováková',
    },
    {
      stars: '★★★★★',
      text: 'We left Excel and chat spreadsheets behind. Attendance and payroll exports land right the first time - finance finally likes it.',
      name: 'Petr Doležal',
    },
    {
      stars: '★★★★☆',
      text: 'Seasonal hiring of temps was twice as fast. Contracts are signed online - papers in the drawer are history.',
      name: 'Michaela Svobodová',
    },
  ],
  footerTagline: 'Shifts, attendance, contracts, and hiring in one app for growing companies.',
  footerProduct: 'Product',
  footerCompany: 'Company',
  footerSupport: 'Support',
  footerLegal: 'Legal',
  footerShifts: 'Shifts',
  footerAttendance: 'Attendance',
  footerContracts: 'Contracts',
  footerHiring: 'Hiring',
  footerAbout: 'About',
  footerCareers: 'Careers',
  footerBlog: 'Blog',
  footerHelp: 'Help',
  footerContact: 'Contact',
  footerStatus: 'Service status',
  footerGdpr: 'GDPR',
  footerTerms: 'Terms of service',
  footerCookies: 'Cookies',
  footerPrivacy: 'Privacy',
  footerTermsShort: 'Terms',
  linkedIn: 'LinkedIn',
};

export function getAboutCopy(lang: 'cs' | 'en'): AboutCopy {
  return lang === 'en' ? EN : CS;
}
